export default {
  _f: 1,
  to: {},
  from: {},
  next: null,
  _pageStage: {
    num: 1,
    start_timestamp: 0,
    fullPath: ''
  },
  maxRedirect: {
    count: 20,
    duration: 3000
  }
}
